import { css } from "styled-components"

const rawHtmlCss = css`
  * + h1,
  * + h2,
  * + h3,
  * + h4,
  * + h5,
  * + h6 {
    margin-top: 1em;
  }

  a,
  p > a {
    color: ${props => props.theme.colors.textColor.link};
  }

  a:visited,
  p > a:visited {
    color: ${props => props.theme.colors.textColor.linkVisited};
  }

  a:focus,
  a:hover,
  p > a:focus,
  p > a:hover {
    color: ${props => props.theme.colors.textHoverColor.link};
  }

  em {
    font-size: inherit;
    font-style: italic;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-bottom: 1em;
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.text.headerLarge};
    font-weight: ${props => props.theme.fontWeights.text.headerLarge};
    line-height: 1.38;
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.text.header};
    font-weight: ${props => props.theme.fontWeights.text.header};
    line-height: 1.38;
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.text.headerSmall};
    font-weight: ${props => props.theme.fontWeights.text.headerSmall};
    line-height: 1.3;
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.text.subheader};
    font-weight: ${props => props.theme.fontWeights.text.subheader};
    line-height: 1.3;
  }

  h4 strong {
    font-weight: ${props => props.theme.fontWeights.bold};
  }

  h5 {
    font-size: ${props => props.theme.fontSizes.text.subheaderSmall};
    font-weight: ${props => props.theme.fontWeights.text.subheaderSmall};
    line-height: 1.38;
  }

  h6 {
    font-family: ${props => props.theme.fonts["20"]};
    font-size: ${props => props.theme.fontSizes.text.displayBody};
    font-weight: ${props => props.theme.fontWeights.regular};
    line-height: 2.222em;
  }

  li,
  p {
    color: inherit;
    font-family: ${props => props.theme.fonts.text.body};
    font-size: ${props => props.theme.fontSizes.text.body};
    line-height: 1.8em;
  }

  h1:last-child,
  h2:last-child,
  h3:last-child,
  h4:last-child,
  h5:last-child,
  h6:last-child,
  p:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: ${props => props.theme.fontWeights.bold};
  }

  ul {
    list-style-type: disc;
    margin: 15px 0 15px 20px;
    padding-left: 20px;
  }

  ol {
    list-style-type: decimal;
    padding-left: 1.5em;
  }

  @media screen and (max-width: 40em) {
    h1 {
      font-size: ${props => props.theme.fontSizes["36"]};
    }

    h2 {
      font-size: ${props => props.theme.fontSizes["28"]};
    }

    h3 {
      font-size: ${props => props.theme.fontSizes["20"]};
    }

    h4 {
      font-size: ${props => props.theme.fontSizes["22"]};
    }

    h6 {
      font-size: ${props => props.theme.fontSizes["20"]};
    }

    li,
    p {
      font-size: ${props => props.theme.fontSizes["17"]};
    }
  }
`

export default rawHtmlCss
